import draggable from './draggable';

export function loadDirectives (app) {
    app.directive('drag', draggable)
}


// WEBPACK FOOTER //
// ./src/common/directives/index.js